import { render } from "./DetailsViewTab.vue?vue&type=template&id=7222b215"
import script from "./DetailsViewTab.vue?vue&type=script&lang=js"
export * from "./DetailsViewTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__